export const carrierNetworkPageStateKey = 'carrier-network-page';

export interface CarrierNetworkState {
	error: string;
	loading: boolean;
	currentPage: number;
	pageSize: number;
	filters: any[];
	sort: any[];
	accountsList: any[];
	total: number;
}

export const initialState: CarrierNetworkState = {
	error: null,
	loading: true,
	currentPage: 0,
	pageSize: 25,
	filters: [],
	sort: [],
	accountsList: [],
	total: 0,
};
